export default __webpack_public_path__ + "static/media/store-icon.13050c12.svg";